import { components } from "./components/index";
import { events } from "./events/index";

const PolicyWordingSection = {
  events,
  components
};

export { PolicyWordingSection }